export const environment = {
  production: false,
  env: 'Desarrollo',
  HomeTitle: 'MDM Utilitarios - Development environment',
  ApiUrl: 'https://gmutlapidev.clavisco.com/',
  recatpchaSiteKey: '6LcEL_EpAAAAAIvuGfcTDMcVd-DZhRdERKZ3HsB-',
  LogRocketId: ''
};
